import '@pages/OrderManagement/styles.css'

import { DestinationsContextProvider } from './Contexts/DestinationsContext'
import { OrderContainersContextProvider } from './Contexts/OrderContainersContext'
import { SupplyOptionContextProvider } from './Contexts/SupplyOptionContext'
import { WizardMasterContextProvider } from './Contexts/WizardMasterContext'
import { OrderWizard } from './OrderWizard'

type OrderModalProps = {
  order?: Gravitate.Order
  showingModal: boolean
  closeModal: () => void
  defaultStore?: string
  selectedOrder?: string
  updateGridOrder?: (order: Gravitate.Order) => void
  selectedRequestedOrder?: Gravitate.Order
  resetTimeoutDelay?: number
}

export function OrderModal({
  order,
  showingModal,
  closeModal,
  defaultStore,
  selectedOrder,
  updateGridOrder,
  selectedRequestedOrder,
  resetTimeoutDelay = 1000,
}: OrderModalProps) {
  return (
    <DestinationsContextProvider defaultStore={defaultStore} selectedOrder={selectedOrder}>
      <WizardMasterContextProvider>
        <SupplyOptionContextProvider>
          <OrderContainersContextProvider>
            <OrderWizard
              order={order}
              showingModal={showingModal}
              selectedOrder={selectedOrder}
              closeModal={closeModal}
              updateGridOrder={updateGridOrder}
              selectedRequestedOrder={selectedRequestedOrder}
              resetTimeoutDelay={resetTimeoutDelay}
            />
          </OrderContainersContextProvider>
        </SupplyOptionContextProvider>
      </WizardMasterContextProvider>
    </DestinationsContextProvider>
  )
}
